// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"e40e7318","420":"0eb74525","780":"efb3c849","830":"c582665f","981":"2d2f52c9"}[chunkId] + ".chunk.js";
};